import { useContext, useEffect } from "react";
import { createContext, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { profileDetailApi } from "services/auth";


const LoaderContext = createContext({});

const defaultDetails = {
    _id: "",
    name: "",
    mobile: "",
    profile: ""
}

const UserProvider = ({ children }) => {
    const [user, setUserData] = useState(defaultDetails);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            const response = await profileDetailApi();
            const profile = response?.data?.data;

            if (profile) {
                setUser(profile);
            }
        } catch (error) {
            console.log({ error });
            logout()
        }
    }

    useEffect(() => {
        const TOKEN = localStorage.getItem("logic_chat_token");
        if (TOKEN) {
            fetchData();
        } else {
            navigate("/");
        }
    }, [])

    const setUser = (data) => {
        if (data) {
            setUserData(prev => ({ ...prev, ...data }));
            setLoading(false);
        } else if (data === null) {
            setUserData(defaultDetails);
        }
    }

    const isLoggedIn = user._id.length ? true : false;

    const logout = () => {
        setLoading(false);
        setUserData(defaultDetails);
        localStorage.removeItem("logic_chat_token");
        navigate("/");
    }

    return (
        <LoaderContext.Provider value={{ user, setUser, isLoggedIn, logout }}>
            {
                loading
                    ?
                    <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Spinner animation="border" role="status" variant="primary"></Spinner>
                        <div>
                            Loading...
                        </div>
                    </div>
                    :
                    <Outlet />
            }
        </LoaderContext.Provider>
    );
};

const useUser = () => useContext(LoaderContext);

export default useUser;
export { UserProvider };